import { createClient, ClientPerspective, SanityClient } from "@sanity/client";

export type { SanityClient };

export const sanityConfig = {
  projectId: "z60zyrm2",
  dataset: "production",
  apiVersion: "2023-06-01",
  /**
   * This token should be created only with VIEWER permissions. It is used to preview content
   * using draft documents with the `previewDrafts` perspective.
   *
   * It does not need to be secret, as it only provides access to drafts, which are already exposed
   * via the preview endpoints. On the balance of convenience vs security, it's better to define
   * the token here rather than every developer needing to create their own token, or copy it.
   *
   * This token is called "Gatsby Viewer Token" in the Sanity API tokens page.
   *
   * @see https://www.sanity.io/organizations/oqaUpjZKw/project/z60zyrm2/api#tokens
   */
  viewerToken:
    "skQFZsAsFnjJyZzQVWWRSr4mVi8h8bif1Odgn9MTJRLWAX3pfj2h24W4C40J0bXIwrJaZnqqElbfSKqIGLJeG17ZvPaXMT9Cmu1BvbCQikbSPsaeSxOKIGLBmXj1jaAzUz5D1X0kE8WvTBzgeY1hMwlSRl322VLpwk6CLgojmAgYJk6sFgMy",
} as const;

/**
 * Sanity client for querying published documents.
 */
const sanityClientPublished = createClient({
  useCdn: true,
  perspective: "published",
  dataset: sanityConfig.dataset,
  token: sanityConfig.viewerToken,
  projectId: sanityConfig.projectId,
  apiVersion: sanityConfig.apiVersion,
});

/**
 * Sanity client for querying published and draft documents.
 */
const sanityClientPreviewDrafts = createClient({
  useCdn: false,
  perspective: "previewDrafts",
  dataset: sanityConfig.dataset,
  token: sanityConfig.viewerToken,
  projectId: sanityConfig.projectId,
  apiVersion: sanityConfig.apiVersion,
});

/**
 * Resolve sanity client from given perspective.
 */
export function sanityFromPerspective(
  perspective: ClientPerspective,
): SanityClient {
  if ("published" === perspective) return sanityClientPublished;
  if ("previewDrafts" === perspective) return sanityClientPreviewDrafts;
  throw new Error(
    `Sanity client not resolvable for perspective ${perspective}.`,
  );
}
